import { jsx as _jsx } from "react/jsx-runtime";
import Radio from '@mui/material/Radio';
import { makeStyles } from 'tss-react/mui';
const useStyles = makeStyles()(theme => ({
    root: {
        color: theme.palette.grey[700],
    },
}));
const CustomRadio = ({ color, ...rest }) => {
    const { classes } = useStyles();
    return (_jsx(Radio, { className: classes.root, color: color || 'primary', ...rest }));
};
export { CustomRadio };
